import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { cloneDeep, baseURL } from "../../../../../constants/commonConstants";
import {
  IViewDepartment,
  IDepartmentData,
} from "../../../../../models/master/department";
import { setDepartment } from "../../../../../store/slices/master/departmentSlice";

const ViewDepartment = (props: IViewDepartment) => {
  const dispatch = useDispatch();
  const { setShowView, department } = props;

  const [data, setData] = useState<IDepartmentData>(cloneDeep(department));

  useEffect(() => {
    if (department) {
      let _department = cloneDeep(department);
      setData(_department);
    }
  }, [department]);

  useEffect(() => {
    return () => {
      dispatch(setDepartment(undefined));
    };
  }, []);

  return (
    <>
      {data && (
        <>
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="addnewbuttonsLabel">
              Department Details
            </h1>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={() => setShowView(false)}
            ></button>
          </div>
          <div className="modal-body">
            <div className="label-group-wrap mt-3">
              <div className="row">
                <div className="col-lg-12 label-group">
                  <p>
                    <img
                      src={
                        data.departmentLogo ? baseURL + data.departmentLogo : ""
                      }
                      alt=""
                      className="w-25"
                    />
                  </p>
                </div>
                <div className="col-lg-6 label-group">
                  <label>Management Name</label>
                  <p>{data.collegeName}</p>
                </div>
                <div className="col-lg-6 label-group">
                  <label>Department Name</label>
                  <p>{data.name}</p>
                </div>
                <div className="col-lg-12 label-group">
                  <label>Address</label>
                  <p>{data.address}</p>
                </div>
                <div className="col-lg-12 label-group">
                  <label>Location</label>
                  <p>{data.location}</p>
                </div>

                <div className="col-lg-12 label-group">
                  <label>Description</label>
                  <p>{data.description}</p>
                </div>

                <div className="col-lg-12 label-group">
                  <label>Login User Name</label>
                  <p>{data.departmentLoginUserName}</p>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                onClick={() => setShowView(false)}
              >
                Close
              </button>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default ViewDepartment;
